export const CheckboxStyle = {
  baseStyle: {
    borderRadius: '4px',
    colorScheme: 'orangeScheme',
    iconColor: 'WHITE',
    color: 'BLACK',
    borderColor: 'GRAY',
    paddingTop: 8,
    size: 'lg',
  },
  defaultProps: {
    borderRadius: '4px',
    colorScheme: 'orangeScheme',
    iconColor: 'WHITE',
    color: 'BLACK',
    borderColor: 'GRAY',
    paddingTop: 8,
    size: 'lg',
  },
};
